module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/download.6edaa11f.svg";